
import { Permission, Resource, PermissionType, Role, Company } from "./types";

/**
 * Resources die NIET onder de algemene "management heeft altijd toegang"-bypass
 * vallen. Voor deze resources moet de permissie expliciet via Rollenbeheer
 * worden gegeven, ook voor management/admins.
 */
export const EXEMPT_FROM_MANAGEMENT_BYPASS: ReadonlySet<Resource> = new Set<Resource>([
  "ordersDecoprof",
]);

export const isExemptFromManagementBypass = (resource: Resource): boolean =>
  EXEMPT_FROM_MANAGEMENT_BYPASS.has(resource);

/**
 * Check if a role has permission for a resource and action within a specific company
 */
export const checkPermission = (
  permissions: Permission[],
  role: Role | undefined,
  resource: Resource,
  permissionType: PermissionType = "read",
  company: Company = "luijten_vvz"
): boolean => {
  if (!role) {
    console.log(`No role provided for permission check on ${resource}`);
    return false;
  }

  console.log(`Checking permission for ${role} - ${resource} - ${permissionType} - company: ${company}`);

  // Management role ALWAYS has access — EXCEPT for resources die expliciet
  // uitgesloten zijn van deze bypass (bijv. ordersDecoprof).
  if (role === "management" && !isExemptFromManagementBypass(resource)) {
    console.log(`Management role automatically has ${permissionType} permission for ${resource}`);
    return true;
  }

  // Special case for feedback - read/write access for all roles
  if (resource === "feedback" && (permissionType === "read" || permissionType === "write")) {
    console.log(`All roles have ${permissionType} access to feedback`);
    return true;
  }

  // Find permission for the role, resource, and company
  const permission = permissions.find(
    p => p.role === role && p.resource === resource && p.company === company
  );

  if (!permission) {
    console.log(`No permission found for ${role} - ${resource} - ${company}`);
    return false;
  }

  // Check if the role has the requested permission type
  const hasAccess = permission[permissionType] === true;
  console.log(`Permission check result for ${role} - ${resource} - ${permissionType} (${company}): ${hasAccess}`);
  return hasAccess;
};
